import React, { useState, useEffect, useRef } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import HomePage from "./pages/HomePage";
import TenantPage from "./pages/TenantPage";
import AboutUs from "./pages/AboutUs";
import MiloWay from "./pages/MiloWay";
import Contact from "./pages/Contact";
import WhatIsMILO from "./pages/WhatIsMILO";
import WhyMILO from "./pages/WhyIsMILOBetter";
import Demo from "./pages/Demo";
import ProfileSetupPage from './pages/ProfileSetupPage';
import CampaignPage from "./pages/Waitlist2";
import BuildingAdminPage from "./pages/BuildingAdminPage";
import ProfileDashboardPage from './pages/ProfileDashboardPage';
import LandlordDashboardPage from './pages/LandlordDashboardPage';
import BuildingManagement from './pages/BuildingManagementPage';
import LoginModal from "./components/AuthItems/LoginModal";
import AlphaRegister from "./components/AuthItems/AlphaRegister";
import ErrorBoundary from "./components/ErrorBoundary";
import platform from "platform";
import Waitlist2 from "./pages/Waitlist2"

const API_BASE_URL = import.meta.env.VITE_API_URL;

function App() {
    const [user, setUser] = useState(null);
    const [isLoginOpen, setIsLoginOpen] = useState(false);
	const [sessionId, setSessionId] = useState(null);
	const apiCalledRef = useRef(false);
	const [authChecked, setAuthChecked] = useState(false);

	// Inside your auth check function:
	useEffect(() => {
	  fetch(`${API_BASE_URL}/auth/check-auth`, { credentials: 'include' })
		.then(res => res.json())
		.then(data => {
		  if (data.loggedIn) {
			setUser(data.user);
			
			localStorage.setItem("demoUserId", data.user.demoUserId);
			localStorage.setItem("tenantUserId", data.user.tenantUserId);
			localStorage.setItem("landlordUserId", data.user.landlordUserId);
			localStorage.setItem("username", data.user.username);
			localStorage.setItem("name", data.user.name);
			
			console.log(sessionStorage);
			if (!sessionStorage.getItem('sessionLogged')) {
			  fetch(`${API_BASE_URL}/auth/log-session`, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				credentials: "include",
				body: JSON.stringify({ activity: 'SiteAccess' }),
			  })
          .then(res => res.json())
          .catch(console.error);

          sessionStorage.setItem('sessionLogged', 'true');
        }
      }
    })
		.catch(console.error)
		.finally(() => setAuthChecked(true)); // <-- fixed this
	}, []);

	
	const contentRef = useRef(null);
    const scrollPosition = useRef(0);


	
	useEffect(() => {
		// Parse user agent info

		// Cookie helper functions
		const sessionCookieName = "session_id";

		function getCookie(name) {
		  const cookies = document.cookie.split(";");
		  for (let cookie of cookies) {
			cookie = cookie.trim();
			if (cookie.startsWith(name + "=")) {
			  return cookie.substring(name.length + 1);
			}
		  }
		  return null;
		}

		function setCookie(name, value, days) {
		  let expires = "";
		  if (days) {
			const date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			expires = "; expires=" + date.toUTCString();
		  }
		  document.cookie = name + "=" + value + expires + "; path=/";
		}

		// Simple UUID generator
		function generateUUID() {
		  if (window.crypto && window.crypto.randomUUID) {
			return window.crypto.randomUUID();
		  } else {
			return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
			  const r = (Math.random() * 16) | 0;
			  const v = c === "x" ? r : (r & 0x3) | 0x8;
			  return v.toString(16);
			});
		  }
		}

		// Check for an existing session cookie
		let id = getCookie(sessionCookieName);
		if (!id) {
		  id = generateUUID();
		  // Set the cookie for 1 day (or omit days for a session cookie that expires on browser close)
		  setCookie(sessionCookieName, id, 90);
		}
		setSessionId(id);
	  }, []);
	  
	  useEffect(() => {
		if (!sessionId) return; // Wait until sessionId is available

		function trackPageView() {
		  // Only send tracking data if the page is visible.
		  if (document.hidden) return;

		  // Prevent duplicate tracking calls.
		  if (apiCalledRef.current || sessionStorage.getItem("trackingSent")) return;
		  apiCalledRef.current = true;
		  sessionStorage.setItem("trackingSent", "true");

		  const dataToSend = {
			browser: platform.name,
			version: platform.version,
			os: platform.os ? platform.os.toString() : "unknown",
			description: platform.description,
			session: sessionId,
		  };

		  fetch(`${API_BASE_URL}/users/track-data`, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(dataToSend),
		  })
			.then((response) => response.json())
			.catch((error) => console.error("Error sending data:", error));
		}

		// If the page is already visible, track immediately.
		if (!document.hidden) {
		  trackPageView();
		} else {
		  // Otherwise, wait until the page becomes visible.
		  document.addEventListener("visibilitychange", trackPageView);
		}

		return () => {
		  document.removeEventListener("visibilitychange", trackPageView);
		};
	  }, [sessionId]);

	


    useEffect(() => {
        const checkAuth = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/auth/check-auth`, {
                    credentials: "include",
                });
                const data = await response.json();
                if (data.loggedIn) {
                    setUser(data.user);
                }
            } catch (error) {
                console.error("Error checking auth:", error);
            }
        };
        checkAuth();
    }, []);

    const handleLogout = async () => {
        await fetch(`${API_BASE_URL}/auth/logout`, {
            method: "POST",
            credentials: "include",
        });
        setUser(null);
    };

    return (
			<Router> {/* ✅ Wrap everything in <Router> */}
				<Navbar user={user} onLogin={() => setIsLoginOpen(true)} onLogout={handleLogout} />
				<div className="core-content" ref={contentRef}>
					<Routes>
						<Route path="/" element={<CampaignPage />} />
						<Route
						  path="/tenant"
						  element={
							authChecked ? (
							  user ? (
								<ErrorBoundary>
								  <TenantPage />
								</ErrorBoundary>
							  ) : (
								<Navigate to="/" replace />
							  )
							) : null
						  }
						/>
						<Route path="/explore" element={
						  <LoginModal isOpen={true} onClose={() => navigate('/')} onLoginSuccess={setUser}  />
						} />
						<Route path="/about" element={<WhatIsMILO />} />
						<Route path="/alphaRegister" element={<AlphaRegister />} />
						<Route path="/why-MILO" element={<WhyMILO />} />
						<Route path="/waitlist" element={<CampaignPage />} />
						<Route path="/waitlist/:referralId?" element={<CampaignPage />} />
						<Route
						  path="/BuildingAdmin"
						  element={
							authChecked ? (
							  user ? <BuildingAdminPage /> : <Navigate to="/" replace />
							) : null
						  }
						/>
						<Route 
						  path="/Demo"
						  element={
							authChecked ? (
							  user ? (
								<>
								  {console.log("Current user:", user)}
								  <Demo />
								</>
							  ) : <Navigate to="/" replace />
							) : null
						  } 
						/>
					    <Route 
						  path="/Setup"
						  element={
							authChecked ? (
							  user ? (
								<>
								  {console.log("Current user:", user)}
								  <ProfileSetupPage />
								</>
							  ) : <Navigate to="/" replace />
							) : null
						  } 
						/>
						<Route path="/Contact/:source?" element={<Contact />} />
						<Route 
						  path="/profile"
						  element={
							authChecked ? (
							  user ? <ProfileDashboardPage /> : <Navigate to="/" replace />
							) : null
						  } 
						/>
						<Route 
						  path="/landlord"
						  element={
							authChecked ? (
							  user ? <LandlordDashboardPage /> : <Navigate to="/" replace />
							) : null
						  } 
						/>
						<Route 
						  path="/landlord/properties"
						  element={
							authChecked ? (
							  user ? <LandlordDashboardPage initialTab="properties" /> : <Navigate to="/" replace />
							) : null
						  } 
						/>
						<Route 
						  path="/landlord/applications"
						  element={
							authChecked ? (
							  user ? <LandlordDashboardPage initialTab="applications" /> : <Navigate to="/" replace />
							) : null
						  } 
						/>
						<Route 
						  path="/landlord/building/:buildingId"
						  element={
							authChecked ? (
							  user ? <BuildingManagement /> : <Navigate to="/" replace />
							) : null
						  } 
						/>
						<Route path="*" element={<Navigate to="/" replace />} />
					</Routes>
				</div>
				<LoginModal 
					isOpen={isLoginOpen} 
					onClose={() => setIsLoginOpen(false)}
					onLoginSuccess={setUser} 
				/>
			</Router>
    );
}

export default App;